@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(-1_486_223_004)
internal val Res.string.compras_panel_title: StringResource by lazy {
      StringResource("string:compras_panel_title", "compras_panel_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24949, 35),
      ))
    }

@delegate:ResourceContentHash(789_425_901)
internal val Res.string.compras_panel_top_increases_table: StringResource by lazy {
      StringResource("string:compras_panel_top_increases_table", "compras_panel_top_increases_table", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24985, 69),
      ))
    }

@delegate:ResourceContentHash(486_931_020)
internal val Res.string.compras_panel_top_reductions_table: StringResource by lazy {
      StringResource("string:compras_panel_top_reductions_table", "compras_panel_top_reductions_table", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25055, 70),
      ))
    }

@delegate:ResourceContentHash(-174_985_268)
internal val Res.string.compras_panel_total: StringResource by lazy {
      StringResource("string:compras_panel_total", "compras_panel_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25255, 35),
      ))
    }

@delegate:ResourceContentHash(-213_513_909)
internal val Res.string.compras_panel_total_increases: StringResource by lazy {
      StringResource("string:compras_panel_total_increases", "compras_panel_total_increases", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25126, 61),
      ))
    }

@delegate:ResourceContentHash(-1_707_795_940)
internal val Res.string.compras_panel_total_reductions: StringResource by lazy {
      StringResource("string:compras_panel_total_reductions", "compras_panel_total_reductions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25188, 66),
      ))
    }

@delegate:ResourceContentHash(-786_943_736)
internal val Res.string.compras_panel_trend_value: StringResource by lazy {
      StringResource("string:compras_panel_trend_value", "compras_panel_trend_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25291, 49),
      ))
    }

@delegate:ResourceContentHash(-166_614_770)
internal val Res.string.compras_panel_variation: StringResource by lazy {
      StringResource("string:compras_panel_variation", "compras_panel_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25341, 87),
      ))
    }

@delegate:ResourceContentHash(-515_927_130)
internal val Res.string.compras_product_details_title: StringResource by lazy {
      StringResource("string:compras_product_details_title", "compras_product_details_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25429, 65),
      ))
    }

@delegate:ResourceContentHash(-1_469_251_034)
internal val Res.string.compras_product_edit_title: StringResource by lazy {
      StringResource("string:compras_product_edit_title", "compras_product_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25495, 54),
      ))
    }

@delegate:ResourceContentHash(1_114_770_570)
internal val Res.string.compras_provision_button: StringResource by lazy {
      StringResource("string:compras_provision_button", "compras_provision_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25550, 48),
      ))
    }

@delegate:ResourceContentHash(1_882_133_967)
internal val Res.string.compras_provision_label: StringResource by lazy {
      StringResource("string:compras_provision_label", "compras_provision_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25599, 55),
      ))
    }

@delegate:ResourceContentHash(-589_616_049)
internal val Res.string.compras_provision_period: StringResource by lazy {
      StringResource("string:compras_provision_period", "compras_provision_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25655, 52),
      ))
    }

@delegate:ResourceContentHash(141_964_893)
internal val Res.string.compras_provision_registered: StringResource by lazy {
      StringResource("string:compras_provision_registered", "compras_provision_registered", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25708, 60),
      ))
    }

@delegate:ResourceContentHash(-1_735_175_032)
internal val Res.string.compras_provision_title: StringResource by lazy {
      StringResource("string:compras_provision_title", "compras_provision_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25769, 59),
      ))
    }

@delegate:ResourceContentHash(689_462_199)
internal val Res.string.compras_refresh: StringResource by lazy {
      StringResource("string:compras_refresh", "compras_refresh", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25829, 35),
      ))
    }

@delegate:ResourceContentHash(-372_906_406)
internal val Res.string.compras_search_placeholder: StringResource by lazy {
      StringResource("string:compras_search_placeholder", "compras_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25865, 74),
      ))
    }

@delegate:ResourceContentHash(48_581_232)
internal val Res.string.compras_summary_complete: StringResource by lazy {
      StringResource("string:compras_summary_complete", "compras_summary_complete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25940, 88),
      ))
    }

@delegate:ResourceContentHash(129_695_026)
internal val Res.string.compras_summary_consolidated: StringResource by lazy {
      StringResource("string:compras_summary_consolidated", "compras_summary_consolidated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26029, 60),
      ))
    }

@delegate:ResourceContentHash(1_865_762_455)
internal val Res.string.compras_summary_empty: StringResource by lazy {
      StringResource("string:compras_summary_empty", "compras_summary_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26090, 101),
      ))
    }

@delegate:ResourceContentHash(-1_653_482_572)
internal val Res.string.compras_tab_summary: StringResource by lazy {
      StringResource("string:compras_tab_summary", "compras_tab_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26192, 35),
      ))
    }

@delegate:ResourceContentHash(749_999_744)
internal val Res.string.compras_table_empty: StringResource by lazy {
      StringResource("string:compras_table_empty", "compras_table_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26228, 95),
      ))
    }

@delegate:ResourceContentHash(-534_948_624)
internal val Res.string.compras_total: StringResource by lazy {
      StringResource("string:compras_total", "compras_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26324, 37),
      ))
    }

@delegate:ResourceContentHash(1_065_593_888)
internal val Res.string.dashboard_hello: StringResource by lazy {
      StringResource("string:dashboard_hello", "dashboard_hello", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26362, 39),
      ))
    }

@delegate:ResourceContentHash(-2_087_702_695)
internal val Res.string.dashboard_open_entries: StringResource by lazy {
      StringResource("string:dashboard_open_entries", "dashboard_open_entries", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26402, 58),
      ))
    }

@delegate:ResourceContentHash(-1_296_653_221)
internal val Res.string.dashboard_pending_operational: StringResource by lazy {
      StringResource("string:dashboard_pending_operational", "dashboard_pending_operational", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26461, 89),
      ))
    }

@delegate:ResourceContentHash(-1_516_379_365)
internal val Res.string.dashboard_pending_rh: StringResource by lazy {
      StringResource("string:dashboard_pending_rh", "dashboard_pending_rh", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26551, 72),
      ))
    }

@delegate:ResourceContentHash(-613_277_502)
internal val Res.string.dashboard_pending_title: StringResource by lazy {
      StringResource("string:dashboard_pending_title", "dashboard_pending_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26624, 47),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.date_picker_cancel: StringResource by lazy {
      StringResource("string:date_picker_cancel", "date_picker_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26672, 38),
      ))
    }

@delegate:ResourceContentHash(1_976_861_733)
internal val Res.string.date_picker_confirm: StringResource by lazy {
      StringResource("string:date_picker_confirm", "date_picker_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26711, 39),
      ))
    }

@delegate:ResourceContentHash(-1_577_155_087)
internal val Res.string.date_picker_none: StringResource by lazy {
      StringResource("string:date_picker_none", "date_picker_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26751, 56),
      ))
    }

@delegate:ResourceContentHash(-611_376_683)
internal val Res.string.date_picker_placeholder: StringResource by lazy {
      StringResource("string:date_picker_placeholder", "date_picker_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26808, 55),
      ))
    }

@delegate:ResourceContentHash(1_693_140_584)
internal val Res.string.dismiss: StringResource by lazy {
      StringResource("string:dismiss", "dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26864, 23),
      ))
    }

@delegate:ResourceContentHash(-1_064_999_811)
internal val Res.string.footer_privacy: StringResource by lazy {
      StringResource("string:footer_privacy", "footer_privacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26888, 54),
      ))
    }

@delegate:ResourceContentHash(657_804_649)
internal val Res.string.footer_rights: StringResource by lazy {
      StringResource("string:footer_rights", "footer_rights", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26943, 61),
      ))
    }

@delegate:ResourceContentHash(-1_433_806_012)
internal val Res.string.footer_year: StringResource by lazy {
      StringResource("string:footer_year", "footer_year", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27005, 31),
      ))
    }

@delegate:ResourceContentHash(1_801_242_163)
internal val Res.string.forms_download_pending: StringResource by lazy {
      StringResource("string:forms_download_pending", "forms_download_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27037, 94),
      ))
    }

@delegate:ResourceContentHash(742_973_724)
internal val Res.string.forms_draft_saved: StringResource by lazy {
      StringResource("string:forms_draft_saved", "forms_draft_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27132, 45),
      ))
    }

@delegate:ResourceContentHash(-478_546_280)
internal val Res.string.forms_link_copied: StringResource by lazy {
      StringResource("string:forms_link_copied", "forms_link_copied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27178, 45),
      ))
    }

@delegate:ResourceContentHash(1_384_265_705)
internal val Res.string.guides_activated: StringResource by lazy {
      StringResource("string:guides_activated", "guides_activated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27224, 44),
      ))
    }

@delegate:ResourceContentHash(-395_878_140)
internal val Res.string.guides_deactivated: StringResource by lazy {
      StringResource("string:guides_deactivated", "guides_deactivated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27269, 50),
      ))
    }

@delegate:ResourceContentHash(-795_202_599)
internal val Res.string.guides_deleted: StringResource by lazy {
      StringResource("string:guides_deleted", "guides_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27320, 46),
      ))
    }

@delegate:ResourceContentHash(324_364_100)
internal val Res.string.guides_image_uploading: StringResource by lazy {
      StringResource("string:guides_image_uploading", "guides_image_uploading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27367, 54),
      ))
    }

@delegate:ResourceContentHash(371_709_992)
internal val Res.string.guides_insert_image: StringResource by lazy {
      StringResource("string:guides_insert_image", "guides_insert_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27422, 47),
      ))
    }

@delegate:ResourceContentHash(317_167_880)
internal val Res.string.guides_manual_saved: StringResource by lazy {
      StringResource("string:guides_manual_saved", "guides_manual_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27470, 47),
      ))
    }

@delegate:ResourceContentHash(-107_240_035)
internal val Res.string.guides_profiles_saved: StringResource by lazy {
      StringResource("string:guides_profiles_saved", "guides_profiles_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27518, 69),
      ))
    }

@delegate:ResourceContentHash(742_973_724)
internal val Res.string.guides_saved: StringResource by lazy {
      StringResource("string:guides_saved", "guides_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27588, 40),
      ))
    }

@delegate:ResourceContentHash(262_910_277)
internal val Res.string.home_empty_updates: StringResource by lazy {
      StringResource("string:home_empty_updates", "home_empty_updates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27629, 86),
      ))
    }

@delegate:ResourceContentHash(-1_973_863_629)
internal val Res.string.home_go_entries: StringResource by lazy {
      StringResource("string:home_go_entries", "home_go_entries", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27716, 51),
      ))
    }

@delegate:ResourceContentHash(-1_581_368_755)
internal val Res.string.home_go_panel: StringResource by lazy {
      StringResource("string:home_go_panel", "home_go_panel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27768, 41),
      ))
    }

@delegate:ResourceContentHash(318_016_909)
internal val Res.string.home_operational: StringResource by lazy {
      StringResource("string:home_operational", "home_operational", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27810, 40),
      ))
    }

@delegate:ResourceContentHash(1_086_632_269)
internal val Res.string.home_pending_month: StringResource by lazy {
      StringResource("string:home_pending_month", "home_pending_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27851, 86),
      ))
    }

@delegate:ResourceContentHash(-1_472_155_885)
internal val Res.string.home_purchases: StringResource by lazy {
      StringResource("string:home_purchases", "home_purchases", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27938, 34),
      ))
    }

@delegate:ResourceContentHash(633_683_851)
internal val Res.string.home_ready: StringResource by lazy {
      StringResource("string:home_ready", "home_ready", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27973, 74),
      ))
    }

@delegate:ResourceContentHash(-989_284_405)
internal val Res.string.home_retry: StringResource by lazy {
      StringResource("string:home_retry", "home_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28048, 42),
      ))
    }

@delegate:ResourceContentHash(-1_739_247_644)
internal val Res.string.home_updates_title: StringResource by lazy {
      StringResource("string:home_updates_title", "home_updates_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28091, 74),
      ))
    }

@delegate:ResourceContentHash(2_103_720_444)
internal val Res.string.notifications_action_activate: StringResource by lazy {
      StringResource("string:notifications_action_activate", "notifications_action_activate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28166, 49),
      ))
    }

@delegate:ResourceContentHash(-1_600_019_577)
internal val Res.string.notifications_action_deactivate: StringResource by lazy {
      StringResource("string:notifications_action_deactivate", "notifications_action_deactivate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28216, 55),
      ))
    }

@delegate:ResourceContentHash(-2_051_160_500)
internal val Res.string.notifications_action_delete: StringResource by lazy {
      StringResource("string:notifications_action_delete", "notifications_action_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28272, 47),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.notifications_action_edit: StringResource by lazy {
      StringResource("string:notifications_action_edit", "notifications_action_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28320, 41),
      ))
    }

@delegate:ResourceContentHash(2_669_562)
internal val Res.string.notifications_banner_view: StringResource by lazy {
      StringResource("string:notifications_banner_view", "notifications_banner_view", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28362, 37),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.notifications_cancel: StringResource by lazy {
      StringResource("string:notifications_cancel", "notifications_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28400, 40),
      ))
    }

@delegate:ResourceContentHash(-1_995_184_619)
internal val Res.string.notifications_empty: StringResource by lazy {
      StringResource("string:notifications_empty", "notifications_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28441, 59),
      ))
    }

@delegate:ResourceContentHash(1_195_366_721)
internal val Res.string.notifications_error: StringResource by lazy {
      StringResource("string:notifications_error", "notifications_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28501, 91),
      ))
    }

@delegate:ResourceContentHash(2_103_719_819)
internal val Res.string.notifications_field_active: StringResource by lazy {
      StringResource("string:notifications_field_active", "notifications_field_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28593, 46),
      ))
    }

@delegate:ResourceContentHash(-2_056_215_000)
internal val Res.string.notifications_field_body: StringResource by lazy {
      StringResource("string:notifications_field_body", "notifications_field_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28640, 44),
      ))
    }

@delegate:ResourceContentHash(1_798_070_103)
internal val Res.string.notifications_field_image: StringResource by lazy {
      StringResource("string:notifications_field_image", "notifications_field_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28685, 77),
      ))
    }

@delegate:ResourceContentHash(-1_814_740_775)
internal val Res.string.notifications_field_priority: StringResource by lazy {
      StringResource("string:notifications_field_priority", "notifications_field_priority", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28763, 52),
      ))
    }

@delegate:ResourceContentHash(-993_143_765)
internal val Res.string.notifications_field_targets: StringResource by lazy {
      StringResource("string:notifications_field_targets", "notifications_field_targets", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28816, 67),
      ))
    }

@delegate:ResourceContentHash(-1_686_223_141)
internal val Res.string.notifications_field_title: StringResource by lazy {
      StringResource("string:notifications_field_title", "notifications_field_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28884, 61),
      ))
    }

@delegate:ResourceContentHash(849_267_998)
internal val Res.string.notifications_go_to: StringResource by lazy {
      StringResource("string:notifications_go_to", "notifications_go_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28946, 39),
      ))
    }

@delegate:ResourceContentHash(29_385_265)
internal val Res.string.notifications_image: StringResource by lazy {
      StringResource("string:notifications_image", "notifications_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28986, 35),
      ))
    }

@delegate:ResourceContentHash(1_601_786_629)
internal val Res.string.notifications_loading: StringResource by lazy {
      StringResource("string:notifications_loading", "notifications_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29022, 69),
      ))
    }

@delegate:ResourceContentHash(-1_165_299_638)
internal val Res.string.notifications_management_empty: StringResource by lazy {
      StringResource("string:notifications_management_empty", "notifications_management_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29092, 82),
      ))
    }

@delegate:ResourceContentHash(-132_931_206)
internal val Res.string.notifications_management_new: StringResource by lazy {
      StringResource("string:notifications_management_new", "notifications_management_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29175, 60),
      ))
    }

@delegate:ResourceContentHash(1_170_845_609)
internal val Res.string.notifications_management_title: StringResource by lazy {
      StringResource("string:notifications_management_title", "notifications_management_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29236, 54),
      ))
    }

@delegate:ResourceContentHash(152_602_920)
internal val Res.string.notifications_mark_read: StringResource by lazy {
      StringResource("string:notifications_mark_read", "notifications_mark_read", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29291, 55),
      ))
    }

@delegate:ResourceContentHash(1_351_800_995)
internal val Res.string.notifications_modal_ack: StringResource by lazy {
      StringResource("string:notifications_modal_ack", "notifications_modal_ack", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29347, 43),
      ))
    }

@delegate:ResourceContentHash(-1_475_283_690)
internal val Res.string.notifications_priority_high: StringResource by lazy {
      StringResource("string:notifications_priority_high", "notifications_priority_high", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29391, 43),
      ))
    }

@delegate:ResourceContentHash(-502_075_968)
internal val Res.string.notifications_priority_low: StringResource by lazy {
      StringResource("string:notifications_priority_low", "notifications_priority_low", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29435, 42),
      ))
    }

@delegate:ResourceContentHash(403_621_433)
internal val Res.string.notifications_priority_medium: StringResource by lazy {
      StringResource("string:notifications_priority_medium", "notifications_priority_medium", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29478, 45),
      ))
    }

@delegate:ResourceContentHash(1_157_981_042)
internal val Res.string.notifications_recent: StringResource by lazy {
      StringResource("string:notifications_recent", "notifications_recent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29524, 40),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.notifications_save: StringResource by lazy {
      StringResource("string:notifications_save", "notifications_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29565, 34),
      ))
    }

@delegate:ResourceContentHash(-604_246_681)
internal val Res.string.notifications_search_placeholder: StringResource by lazy {
      StringResource("string:notifications_search_placeholder", "notifications_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29600, 68),
      ))
    }

@delegate:ResourceContentHash(2_103_719_819)
internal val Res.string.notifications_status_active: StringResource by lazy {
      StringResource("string:notifications_status_active", "notifications_status_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29669, 47),
      ))
    }

@delegate:ResourceContentHash(-1_466_765_808)
internal val Res.string.notifications_status_inactive: StringResource by lazy {
      StringResource("string:notifications_status_inactive", "notifications_status_inactive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29717, 49),
      ))
    }

@delegate:ResourceContentHash(1_469_936_197)
internal val Res.string.notifications_target_add: StringResource by lazy {
      StringResource("string:notifications_target_add", "notifications_target_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29767, 44),
      ))
    }

@delegate:ResourceContentHash(-1_005_076_039)
internal val Res.string.notifications_target_all: StringResource by lazy {
      StringResource("string:notifications_target_all", "notifications_target_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29812, 56),
      ))
    }

@delegate:ResourceContentHash(-61_876_579)
internal val Res.string.notifications_target_permission: StringResource by lazy {
      StringResource("string:notifications_target_permission", "notifications_target_permission", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29869, 55),
      ))
    }

@delegate:ResourceContentHash(1_382_276_298)
internal val Res.string.notifications_target_unit: StringResource by lazy {
      StringResource("string:notifications_target_unit", "notifications_target_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29925, 49),
      ))
    }

@delegate:ResourceContentHash(-1_705_595_555)
internal val Res.string.notifications_target_user: StringResource by lazy {
      StringResource("string:notifications_target_user", "notifications_target_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29975, 53),
      ))
    }

@delegate:ResourceContentHash(296_602_410)
internal val Res.string.notifications_unread_short: StringResource by lazy {
      StringResource("string:notifications_unread_short", "notifications_unread_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30029, 54),
      ))
    }

@delegate:ResourceContentHash(-1_700_290_175)
internal val Res.string.operational_action_approve: StringResource by lazy {
      StringResource("string:operational_action_approve", "operational_action_approve", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30084, 46),
      ))
    }

@delegate:ResourceContentHash(-2_137_438_734)
internal val Res.string.operational_action_clear: StringResource by lazy {
      StringResource("string:operational_action_clear", "operational_action_clear", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30131, 40),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.operational_action_edit: StringResource by lazy {
      StringResource("string:operational_action_edit", "operational_action_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30172, 39),
      ))
    }

@delegate:ResourceContentHash(-1_717_971_154)
internal val Res.string.operational_action_export_pdf: StringResource by lazy {
      StringResource("string:operational_action_export_pdf", "operational_action_export_pdf", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30212, 53),
      ))
    }

@delegate:ResourceContentHash(-1_329_692_217)
internal val Res.string.operational_action_reject: StringResource by lazy {
      StringResource("string:operational_action_reject", "operational_action_reject", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30266, 45),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.operational_action_save: StringResource by lazy {
      StringResource("string:operational_action_save", "operational_action_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30312, 39),
      ))
    }

@delegate:ResourceContentHash(-1_648_534_997)
internal val Res.string.operational_action_submit: StringResource by lazy {
      StringResource("string:operational_action_submit", "operational_action_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30352, 41),
      ))
    }

@delegate:ResourceContentHash(2_669_562)
internal val Res.string.operational_action_view: StringResource by lazy {
      StringResource("string:operational_action_view", "operational_action_view", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30394, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("compras_panel_title", Res.string.compras_panel_title)
  map.put("compras_panel_top_increases_table", Res.string.compras_panel_top_increases_table)
  map.put("compras_panel_top_reductions_table", Res.string.compras_panel_top_reductions_table)
  map.put("compras_panel_total", Res.string.compras_panel_total)
  map.put("compras_panel_total_increases", Res.string.compras_panel_total_increases)
  map.put("compras_panel_total_reductions", Res.string.compras_panel_total_reductions)
  map.put("compras_panel_trend_value", Res.string.compras_panel_trend_value)
  map.put("compras_panel_variation", Res.string.compras_panel_variation)
  map.put("compras_product_details_title", Res.string.compras_product_details_title)
  map.put("compras_product_edit_title", Res.string.compras_product_edit_title)
  map.put("compras_provision_button", Res.string.compras_provision_button)
  map.put("compras_provision_label", Res.string.compras_provision_label)
  map.put("compras_provision_period", Res.string.compras_provision_period)
  map.put("compras_provision_registered", Res.string.compras_provision_registered)
  map.put("compras_provision_title", Res.string.compras_provision_title)
  map.put("compras_refresh", Res.string.compras_refresh)
  map.put("compras_search_placeholder", Res.string.compras_search_placeholder)
  map.put("compras_summary_complete", Res.string.compras_summary_complete)
  map.put("compras_summary_consolidated", Res.string.compras_summary_consolidated)
  map.put("compras_summary_empty", Res.string.compras_summary_empty)
  map.put("compras_tab_summary", Res.string.compras_tab_summary)
  map.put("compras_table_empty", Res.string.compras_table_empty)
  map.put("compras_total", Res.string.compras_total)
  map.put("dashboard_hello", Res.string.dashboard_hello)
  map.put("dashboard_open_entries", Res.string.dashboard_open_entries)
  map.put("dashboard_pending_operational", Res.string.dashboard_pending_operational)
  map.put("dashboard_pending_rh", Res.string.dashboard_pending_rh)
  map.put("dashboard_pending_title", Res.string.dashboard_pending_title)
  map.put("date_picker_cancel", Res.string.date_picker_cancel)
  map.put("date_picker_confirm", Res.string.date_picker_confirm)
  map.put("date_picker_none", Res.string.date_picker_none)
  map.put("date_picker_placeholder", Res.string.date_picker_placeholder)
  map.put("dismiss", Res.string.dismiss)
  map.put("footer_privacy", Res.string.footer_privacy)
  map.put("footer_rights", Res.string.footer_rights)
  map.put("footer_year", Res.string.footer_year)
  map.put("forms_download_pending", Res.string.forms_download_pending)
  map.put("forms_draft_saved", Res.string.forms_draft_saved)
  map.put("forms_link_copied", Res.string.forms_link_copied)
  map.put("guides_activated", Res.string.guides_activated)
  map.put("guides_deactivated", Res.string.guides_deactivated)
  map.put("guides_deleted", Res.string.guides_deleted)
  map.put("guides_image_uploading", Res.string.guides_image_uploading)
  map.put("guides_insert_image", Res.string.guides_insert_image)
  map.put("guides_manual_saved", Res.string.guides_manual_saved)
  map.put("guides_profiles_saved", Res.string.guides_profiles_saved)
  map.put("guides_saved", Res.string.guides_saved)
  map.put("home_empty_updates", Res.string.home_empty_updates)
  map.put("home_go_entries", Res.string.home_go_entries)
  map.put("home_go_panel", Res.string.home_go_panel)
  map.put("home_operational", Res.string.home_operational)
  map.put("home_pending_month", Res.string.home_pending_month)
  map.put("home_purchases", Res.string.home_purchases)
  map.put("home_ready", Res.string.home_ready)
  map.put("home_retry", Res.string.home_retry)
  map.put("home_updates_title", Res.string.home_updates_title)
  map.put("notifications_action_activate", Res.string.notifications_action_activate)
  map.put("notifications_action_deactivate", Res.string.notifications_action_deactivate)
  map.put("notifications_action_delete", Res.string.notifications_action_delete)
  map.put("notifications_action_edit", Res.string.notifications_action_edit)
  map.put("notifications_banner_view", Res.string.notifications_banner_view)
  map.put("notifications_cancel", Res.string.notifications_cancel)
  map.put("notifications_empty", Res.string.notifications_empty)
  map.put("notifications_error", Res.string.notifications_error)
  map.put("notifications_field_active", Res.string.notifications_field_active)
  map.put("notifications_field_body", Res.string.notifications_field_body)
  map.put("notifications_field_image", Res.string.notifications_field_image)
  map.put("notifications_field_priority", Res.string.notifications_field_priority)
  map.put("notifications_field_targets", Res.string.notifications_field_targets)
  map.put("notifications_field_title", Res.string.notifications_field_title)
  map.put("notifications_go_to", Res.string.notifications_go_to)
  map.put("notifications_image", Res.string.notifications_image)
  map.put("notifications_loading", Res.string.notifications_loading)
  map.put("notifications_management_empty", Res.string.notifications_management_empty)
  map.put("notifications_management_new", Res.string.notifications_management_new)
  map.put("notifications_management_title", Res.string.notifications_management_title)
  map.put("notifications_mark_read", Res.string.notifications_mark_read)
  map.put("notifications_modal_ack", Res.string.notifications_modal_ack)
  map.put("notifications_priority_high", Res.string.notifications_priority_high)
  map.put("notifications_priority_low", Res.string.notifications_priority_low)
  map.put("notifications_priority_medium", Res.string.notifications_priority_medium)
  map.put("notifications_recent", Res.string.notifications_recent)
  map.put("notifications_save", Res.string.notifications_save)
  map.put("notifications_search_placeholder", Res.string.notifications_search_placeholder)
  map.put("notifications_status_active", Res.string.notifications_status_active)
  map.put("notifications_status_inactive", Res.string.notifications_status_inactive)
  map.put("notifications_target_add", Res.string.notifications_target_add)
  map.put("notifications_target_all", Res.string.notifications_target_all)
  map.put("notifications_target_permission", Res.string.notifications_target_permission)
  map.put("notifications_target_unit", Res.string.notifications_target_unit)
  map.put("notifications_target_user", Res.string.notifications_target_user)
  map.put("notifications_unread_short", Res.string.notifications_unread_short)
  map.put("operational_action_approve", Res.string.operational_action_approve)
  map.put("operational_action_clear", Res.string.operational_action_clear)
  map.put("operational_action_edit", Res.string.operational_action_edit)
  map.put("operational_action_export_pdf", Res.string.operational_action_export_pdf)
  map.put("operational_action_reject", Res.string.operational_action_reject)
  map.put("operational_action_save", Res.string.operational_action_save)
  map.put("operational_action_submit", Res.string.operational_action_submit)
  map.put("operational_action_view", Res.string.operational_action_view)
}
